import { reaction } from 'mobx';
import { useEffect } from 'react';

export function useMobxReaction<T>(
	expressionFn: () => T,
	effect: (arg: T) => void
) {
	useEffect(() => {
		const dispose = reaction(expressionFn, effect);
		return () => dispose();
	}, [effect, expressionFn]);
}
